import React from 'react';
import SvgIcon from '../../svgIcon/SvgIcon';

export function ChevronPrev(props) {
    return (
        <SvgIcon {...props}>
            <path d="M27.7 20.8l-11-11c-.4-.4-1-.4-1.4 0l-11 11c-.4.4-.4 1 0 1.4.4.4 1 .4 1.4 0L16 11.9l10.3 10.3c.4.4 1 .4 1.4 0s.4-1 0-1.4z" transform="rotate(-90 15.999999046325685,16)" />
        </SvgIcon>
    );
}

ChevronPrev.defaultProps = {
    viewBox: '0 0 32 32'
};

export default ChevronPrev;
